import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import qs from "query-string";
import debounce from "lodash/debounce";
import { getMinMaxCordinates } from "utils/helpers";
import { useLocation } from "react-router";

export default function useSyncCoordinateQueries({ bounds, dateRange, selectedChannels }) {
  const [query, setQuery] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const updateURL = useCallback(
    searchString => {
      setQuery(searchString);
      navigate({ pathname: "/map", search: `?${searchString}` });
    },
    [navigate]
  );

  useEffect(() => {
    if (location.pathname !== "/map") {
      return;
    }
    const coordinates = getMinMaxCordinates(bounds);
    if (isNaN(coordinates.start_lat)) {
      return;
    }
    const searchString = qs.stringify(
      { channels: selectedChannels, ...coordinates, ...dateRange },
      { arrayFormat: "comma" }
    );
    updateURL(searchString);
  }, [bounds, dateRange, location.pathname, selectedChannels, updateURL]);
  return query;
}
